export function setCookie(name, value) {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
}

export function getCookie(name) {
    const storedCookie = document.cookie.split('; ').find(row => row.startsWith(`${name}=`));
    return storedCookie ? JSON.parse(decodeURIComponent(storedCookie.split('=')[1])) : null;
}

export function clearCookie(name) {
    document.cookie = `${name}=; expires=${new Date(0).toUTCString()}; path=/`;
}